<template>
	<div>
		<header>
			企业名称：
			<el-input v-model="search.companyName" placeholder="请输入企业名称" style="width: 150px"></el-input>
			项目名称：
			<el-input v-model="search.projectName" placeholder="请输入内容" style="width: 150px" clearable></el-input>
			硬件名称：
			<el-select v-model="search.module" style="width: 150px" placeholder="请选择" filterable clearable>
				<el-option v-for="pro in hardwareList" :key="pro.value" :label="pro.name" :value="pro.value">
				</el-option>
			</el-select>
			<el-button type="primary" icon="el-icon-search" style="margin-left: 10px"
				@click="pageIndex = 1; onSearch()">查询</el-button>
			<el-button type="primary" icon="el-icon-top-right" style="margin-left: 10px"
				@click="exportHandler" :disabled="!search.companyName">导出</el-button>
		</header>
		<el-table :data="tableData" style="width: 100%;margin-top: 20px;" border :span-method="objectSpanMethod">
			<el-table-column type="index" label="序号" width="80"></el-table-column>
			<el-table-column prop="companyName" label="企业名称"></el-table-column>
			<el-table-column prop="projectName" label="项目名称"></el-table-column>
			<el-table-column prop="moduleName" label="硬件名称"></el-table-column>
			
			<el-table-column prop="equipmentNum" label="设备编号"></el-table-column>
			<el-table-column label="是否虚假设备">
				<template slot-scope="scope">
					<div 
						style="width: 100%;height: 100%;cursor: pointer;"
						@click="changeEquipment(scope.row)"
					>
						{{ scope.row.isFalseDevice ? '是' : '否' }}
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="manufacturer" label="硬件厂商"></el-table-column>
			<el-table-column prop="installTime" label="安装时间"></el-table-column>
			<el-table-column prop="deviceCount" label="此项目硬件总数"></el-table-column>
		</el-table>
		<div class="tc" style="margin-top:20px">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
import { getProjectMonthlyReportList, exportProjectMonthlyReport, changeVirtualDevice } from '@/api/hardwarestatistic';
import { spanRow } from "element-ui-table-span-method";
export default {
	name: 'monthReport',
	props: {
		hardwareList: {
			type: Array,
			default: () => []
		}
	},
	data () {
		return {
			search: {
				module: "",
				companyName: "",
				projectName: ""
			},
			pageIndex: 1,
			pageSize: 10,
			total: 100,
			tableData: [],
		}
	},
	mounted () {
		this.onSearch();
	},
	methods: {
		changeEquipment(row) {
			this.$confirm(`将是否虚拟设备变更为： ${row.isFalseDevice ? '否' : '是'}`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				beforeClose: (action, instance, done) => {
					if (action === 'confirm') {
						instance.confirmButtonLoading = true;
						changeVirtualDevice({ DeviceCode: row.equipmentNum, Status: row.isFalseDevice?0:1 }).then(res => {
							if (res.data.statusCode === 200) {
								done();
								instance.confirmButtonLoading = false;
								this.$message({ type: 'success', message: '操作成功' });
								this.onSearch();
							} else {
								done();
								instance.confirmButtonLoading = false;
							}
						}).catch(() => { })
					} else {
						done();
					}
				}
			}).then(() => { }).catch(() => { });
		},
		flitterData(arr) {
            let spanOneArr = [],
                spanTwoArr = [],
                spanThreeArr = [],
                spanFourArr = [],
                concatOne = 0,
                concatTwo = 0,
                concatThree = 0,
                concatFour = 0;
            arr.forEach((item, index) => {
                if (index === 0) {
                    spanOneArr.push(1);
                    spanTwoArr.push(1);
                    spanThreeArr.push(1);
                    spanFourArr.push(1);
                } else {
                    if (item.companyName=== arr[index - 1].companyName) { //第一列需合并相同内容的判断条件
                        spanOneArr[concatOne] += 1;
                        spanOneArr.push(0);
                    } else {
                        spanOneArr.push(1);
                        concatOne = index;
                    }
                    if (item.projectName=== arr[index - 1].projectName&& item.companyName=== arr[index - 1].companyName) {//第二列需合并相同内容的判断条件
                        spanTwoArr[concatTwo] += 1;
                        spanTwoArr.push(0);
                    } else {
                        spanTwoArr.push(1);
                        concatTwo = index;
                    }
                    if (item.moduleName=== arr[index - 1].moduleName&& item.projectName=== arr[index - 1].projectName&& item.companyName=== arr[index - 1].companyName) {//第三列需合并相同内容的判断条件
                        spanThreeArr[concatThree] += 1;
                        spanThreeArr.push(0);
                    } else {
                        spanThreeArr.push(1);
                        concatThree = index;
                    }
					// && item.moduleName=== arr[index - 1].moduleName
                    if (item.deviceName=== arr[index - 1].deviceName&& item.projectName=== arr[index - 1].projectName&& item.companyName=== arr[index - 1].companyName) {//第三列需合并相同内容的判断条件
                        spanFourArr[concatFour] += 1;
                        spanFourArr.push(0);
                    } else {
                        spanFourArr.push(1);
                        concatFour = index;
                    }
                }
            })
            return {
                one: spanOneArr,
                two: spanTwoArr,
                three: spanThreeArr,
                four: spanFourArr,
            }
 
        },
		objectSpanMethod ({ row, column, rowIndex, columnIndex }) {

			if (columnIndex === 1) {
                const _row = (this.flitterData(this.tableData).one)[rowIndex];
                const _col = _row > 0 ? 1 : 0;
                return {
                    rowspan: _row,
                    colspan: _col
                };
            }
            if (columnIndex === 2) {
                const _row = (this.flitterData(this.tableData).two)[rowIndex];
                const _col = _row > 0 ? 1 : 0;
                return {
                    rowspan: _row,
                    colspan: _col
                };
            }
            if (columnIndex === 3) {
                const _row = (this.flitterData(this.tableData).three)[rowIndex];
                const _col = _row > 0 ? 1 : 0;
                return {
                    rowspan: _row,
                    colspan: _col
                };
            }
            if (columnIndex === 8) {
                const _row = (this.flitterData(this.tableData).four)[rowIndex];
                const _col = _row > 0 ? 1 : 0;
                return {
                    rowspan: _row,
                    colspan: _col
                };
            }

			return;
			
			// 如果是公司名称发生变化，计算 rowspan
			if (row.companyName !== this.tableData[rowIndex - 1].companyName) {
				// 如果公司名称相同，检查当前列的值是否与前一行相同
				const prevRow = this.tableData[rowIndex - 1];
				if (prevRow[column.property] === row[column.property]) {
					return { rowspan: 0, colspan: 0 };
				} else {
					// 如果当前列的值与前一行不同，重新计算 rowspan
					let count = 1;
					for (let i = rowIndex + 1; i < this.tableData.length; i++) {
						if (this.tableData[i].companyName === row.companyName && this.tableData[i][column.property] === row[column.property]) {
							count++;
						} else {
							break;
						}
					}
					return { rowspan: count, colspan: 1 };
				}
			}

			return;


			const columnsToMergeByEquipment = ['companyName'];
			const columnsToMergeByMonitorPlace = ['projectName', 'moduleName', 'manufacturer', 'deviceCount'];

			if (columnsToMergeByEquipment.includes(column.property)) {
				// 如果是第一行或者设备编号发生变化，计算 rowspan
				if (rowIndex === 0 || row.companyName !== this.tableData[rowIndex - 1].companyName) {
					let count = 1;
					for (let i = rowIndex + 1; i < this.tableData.length; i++) {
						if (this.tableData[i].companyName === row.companyName) {
							count++;
						} else {
							break;
						}
					}
					return { rowspan: count, colspan: 1 };
				} else {
					// 如果设备编号相同，检查当前列的值是否与前一行相同
					const prevRow = this.tableData[rowIndex - 1];
					if (prevRow[column.property] === row[column.property]) {
						return { rowspan: 0, colspan: 0 };
					} else {
						// 如果当前列的值与前一行不同，重新计算 rowspan
						let count = 1;
						for (let i = rowIndex + 1; i < this.tableData.length; i++) {
							if (this.tableData[i].companyName === row.companyName && this.tableData[i][column.property] === row[column.property]) {
								count++;
							} else {
								break;
							}
						}
						return { rowspan: count, colspan: 1 };
					}
				}
			} else if (columnsToMergeByMonitorPlace.includes(column.property)) {
				// 如果是第一行或者设备编号发生变化，或者监测位置编号发生变化，计算 rowspan
				if (rowIndex === 0 || row.companyName !== this.tableData[rowIndex - 1].companyName) {
					let count = 1;
					for (let i = rowIndex + 1; i < this.tableData.length; i++) {
						if (this.tableData[i].companyName === row.companyName) {
							if (column.property === 'projectName') {
								if (this.tableData[i].projectName === row.projectName) {
									count++;
								} else {
									break;
								}
							} else {
								if (this.tableData[i][column.property] === row[column.property]) {
									count++;
								} else {
									break;
								}
							}
						} else {
							break;
						}
					}
					return { rowspan: count, colspan: 1 };
				} else {
					// 如果设备编号相同，检查当前列的值是否与前一行相同
					const prevRow = this.tableData[rowIndex - 1];
					if (prevRow[column.property] === row[column.property]) {
						return { rowspan: 0, colspan: 0 };
					} else {
						// 如果当前列的值与前一行不同，重新计算 rowspan
						let count = 1;
						for (let i = rowIndex + 1; i < this.tableData.length; i++) {
							if (this.tableData[i].companyName === row.companyName) {
								if (column.property === 'projectName') {
									if (this.tableData[i].projectName === row.projectName) {
										count++;
									} else {
										break;
									}
								} else {
									if (this.tableData[i][column.property] === row[column.property]) {
										count++;
									} else {
										break;
									}
								}
							} else {
								break;
							}
						}
						return { rowspan: count, colspan: 1 };
					}
				}
			}

			// 对于不需要合并的列，直接返回
			return { rowspan: 1, colspan: 1 };
		},
		exportHandler() {
			let params = this.generateParams();
			delete params.pageSize;
			delete params.pageIndex;
			exportProjectMonthlyReport(params).then(res => {
				if (res.data.statusCode === 200) {
					window.open(`${this.$exportPrefix}${res.data.data}`);
				}
			}).catch(() => {})
		},
		generateParams () {
			return {
				pageSize: this.pageSize,
				pageIndex: this.pageIndex,
				module: this.search.module !== "" ? this.search.module : -1,
				companyName: this.search.companyName,
				projectName: this.search.projectName
			}
		},
		onSearch () {
			let params = this.generateParams();
			getProjectMonthlyReportList(params).then(res => {
				if (res.data.statusCode === 200) {
					this.tableData = res.data.data.items;
					this.total = res.data.data.totalCount;
				}
			}).catch(() => { })
		},
		handleSizeChange (val) {
			this.pageSize = val;
			this.pageIndex = 1;
			this.onSearch();
		},
		handleCurrentChange (val) {
			this.pageIndex = val;
			this.onSearch();
			if(this.pageIndex*this.pageSize>this.total - this.pageSize) this.onSearch();
		}
	}
}
</script>